// Create a context
import React, { createContext, useContext, useState, ReactNode } from "react";

type GlobalStateContextType = {
  LogInUserName: string;
  setLogInUserName: Function;
  LogInUserImage: string;
  setLogInUserImage: Function;
  LogInUserRole: string;
  setLogInUserRole: Function;
  ManageAdmin: boolean;
  setManageAdmin: Function;
  DirectorAccess: boolean;
  setDirectorAccess: Function;
  OverseasAccess: boolean;
  setOverseasAccess: Function;
  NotificationObject: {
    ShowPopup: boolean;
    Heading: string;
    Message: string;
  };
  setNotificationObject: Function;
  ConfirmationObject: {
    ShowPopup: boolean;
    Heading: string;
    Message: string;
    ID: number;
    SelectedID: number;
  };
  setConfirmationObject: Function;

  ManageObj: {
    ManageAdmineSignEtc: boolean;
    ReportingAccess: boolean;
    MakeSpecialBP: boolean;
  };
  setManageObj: Function;

  AppAccessLevelData: {
    FinanceDashboard: 0;
    FinanceInput: 0;
    SalesInput: 0;
    CustomerServiceInput: 0;
    NetworkInput: 0;
    BrandInput: 0;
    ExceptionsInput: 0;
    ReInvestmentInput: 0;
    DID: 0;
  };
  setAppAccessLevelData: Function;

  AccessData: boolean;
  setAccessData: Function;

  UpdateNotificationCount: any;
  setUpdateNotificationCount: Function;

  TopFilterData: { IBBProgramID: any; QuarterID: any; IBBScorecardID: any };
  setTopFilterData: Function;
};

const GlobalStateContext = createContext<GlobalStateContextType | undefined>(
  undefined
);

export const GlobalStateProvider = ({ children }: any) => {
  const [LogInUserName, setLogInUserName] = useState<string>("");
  const [LogInUserImage, setLogInUserImage] = useState<string>("");
  const [LogInUserRole, setLogInUserRole] = useState<string>("");
  const [ManageAdmin, setManageAdmin] = useState<boolean>(false);
  const [DirectorAccess, setDirectorAccess] = useState<boolean>(false);
  const [OverseasAccess, setOverseasAccess] = useState<boolean>(false);
  const [NotificationObject, setNotificationObject] = useState({
    ShowPopup: false,
    Heading: "",
    Message: "",
  });
  const [ConfirmationObject, setConfirmationObject] = useState({
    ShowPopup: false,
    Heading: "",
    Message: "",
    ID: 0,
    SelectedID: 0,
  });

  const [AppAccessLevelData, setAppAccessLevelData] = useState<any>({
    FinanceDashboard: 0,
    FinanceInput: 0,
    SalesInput: 0,
    CustomerServiceInput: 0,
    NetworkInput: 0,
    BrandInput: 0,
    ExceptionsInput: 0,
    ReInvestmentInput: 0,
    DID: 0,
  });

  const [ManageObj, setManageObj] = useState<any>({
    ManageAdmineSignEtc: false,
    ReportingAccess: false,
    MakeSpecialBP: false,
  });

  const [AccessData, setAccessData] = useState<any>([]);
  const [UpdateNotificationCount, setUpdateNotificationCount] = useState<boolean>(false);
  const [TopFilterData, setTopFilterData] = useState({
    IBBProgramID: 0,
    QuarterID: 0,
    IBBScorecardID: 0,
  });

  return (
    <GlobalStateContext.Provider
      value={{
        LogInUserName,
        setLogInUserName,
        LogInUserImage,
        setLogInUserImage,
        LogInUserRole,
        setLogInUserRole,
        ManageAdmin,
        setManageAdmin,
        DirectorAccess,
        setDirectorAccess,
        OverseasAccess,
        setOverseasAccess,
        NotificationObject,
        setNotificationObject,
        ConfirmationObject,
        setConfirmationObject,
        AppAccessLevelData,
        setAppAccessLevelData,
        ManageObj,
        setManageObj,
        AccessData,
        setAccessData,
        UpdateNotificationCount,
        setUpdateNotificationCount,
        TopFilterData,
        setTopFilterData,
      }}
    >
      {children}
    </GlobalStateContext.Provider>
  );
};

export const useGlobalState = () => {
  const context = useContext(GlobalStateContext);
  if (!context) {
    throw new Error("useGlobalState must be used within a GlobalStateProvider");
  }
  return context;
};
